var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { TextFilterCell } from '@progress/kendo-react-data-tools';
import { textFilterOperators, localizeFilter } from './utils';
import { useLocalization } from '@progress/kendo-react-intl';
export var TreeListTextFilter = function (props) {
    var operators = props.operators, restProps = __rest(props, ["operators"]);
    return (React.createElement(TextFilterCell, __assign({}, localizeFilter(useLocalization(), operators || textFilterOperators), restProps)));
};
//# sourceMappingURL=TreeListTextFilter.js.map